import { gql } from '@apollo/client';

export default gql`
  mutation ($token: String!) {
    logout(token: $token)
  }
`;
